import { FC } from 'react';

type Props = {
	className?: string;
};

const ComposeIcon: FC<Props> = ({ className }) => {
	return (
		<svg
			width='20'
			height='20'
			viewBox='0 0 20 20'
			xmlns='http://www.w3.org/2000/svg'
			fill='none'
			stroke='#2B2B2B'
			className={className}>
			<path
				d='M3 15.7528V17.0002H4.24743C5.2573 17.0002 5.76223 17.0002 6.21626 16.8121C6.67029 16.6241 7.02733 16.267 7.74141 15.5529L15.8648 7.42955C16.5916 6.70273 16.955 6.33931 16.9952 5.8933C17.0018 5.81957 17.0018 5.74538 16.9952 5.67165C16.955 5.22564 16.5916 4.86222 15.8648 4.1354C15.1379 3.40858 14.7745 3.04516 14.3285 3.00498C14.2548 2.99834 14.1806 2.99834 14.1068 3.00498C13.6608 3.04516 13.2975 3.40858 12.5706 4.1354L4.44725 12.2587C3.73317 12.9728 3.37614 13.3299 3.18806 13.7839C3 14.2379 3 14.7428 3 15.7528Z'
				stroke='inherit'
				strokeWidth='1.25'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
			<path
				d='M11.2354 5.4707L14.5295 8.76486'
				stroke='inherit'
				strokeWidth='1.25'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
		</svg>
	);
};

export default ComposeIcon;
